export const fetchRFPData = async (userInfo, selectedRFP) => {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
    try {
        const response = await fetch(`${API_BASE_URL}/api/rfp/getRFP`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body: JSON.stringify({
                userId: userInfo._id,
                _id: selectedRFP,
            }),
        });
        const data = await response.json();
        if (response.ok) {
            return data;
        } else {
            console.error("Error fetching RFP data:", data.message);
        }
    } catch (error) {
        console.error("Network error:", error);
    }
};